<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="workerGroup.pkId ? '编辑' : '新建'"
      width="1000px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="workerGroup"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="workerGroup.pkId" :span="12">
          <el-form-item label="班组编号">
            <el-input v-model="workerGroup.groupNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组名称" prop="groupName">
            <el-input v-model="workerGroup.groupName" placeholder="请输入班组名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组分类" prop="groupType">
            <el-select v-model="workerGroup.groupType" clearable placeholder="请选择班组分类">
              <el-option v-for="(item, index) in groupTypeList" :key="index" :label="item.name" :value="item.code"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组长" prop="groupLeaderName">
            <el-input v-model="workerGroup.groupLeaderName" readonly placeholder="请选择班组长">
              <el-button slot="append" @click="$refs.selectLeader.open()">选择</el-button>
            </el-input>
            <employee-select ref="selectLeader" @select="onSelectLeader"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="note">
            <el-input v-model="workerGroup.note" type="textarea" :rows="1" placeholder="请输入备注"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">班组成员</div>
      <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMember.open()"> 添加 </el-button>
      <el-table :data="groupMembersDetail" border>
        <el-table-column type="index" label="#" align="center" width="55"/>
        <el-table-column prop="employeeNO" align="center" label="编号"/>
        <el-table-column prop="employeeName" align="center" label="姓名"/>
        <el-table-column prop="gender" width="60" align="center" label="性别">
          <template v-slot="scope">
            {{constant.gender[scope.row.gender]}}
          </template>
        </el-table-column>
        <el-table-column
            prop="departmentName"
            min-width="120"
            align="left"
            show-overflow-tooltip
            label="部门"/>
        <el-table-column
            prop="postName"
            min-width="120"
            show-overflow-tooltip
            align="left"
            label="职位"/>
        <el-table-column prop="outerNo" align="center" label="外部编号"/>
        <el-table-column prop="telephone" min-width="100" align="center" label="电话"/>
        <el-table-column prop="mobile" min-width="100" align="center" label="手机"/>
        <el-table-column label="操作" align="center" width="80px">
          <template v-slot="scope">
            <el-button type="danger" @click="onDeleteMember(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top: 10px">班组工作中心</div>
      <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectWorkCenter.open()"> 添加 </el-button>
      <el-table :data="groupWorkCentersDetail" border>
        <el-table-column prop="workCenterNo" align="center" label="中心编号" width="120"/>
        <el-table-column prop="workCenterName" align="left" show-overflow-tooltip label="中心名称"/>
        <el-table-column prop="productionTypeName" align="center" label="生产类型" width="120"/>
        <el-table-column prop="bindVehicleTypeName" align="center" label="载具绑定" width="120"/>
        <el-table-column prop="isLoadMaterial" align="center" label="上料认证" width="120">
          <template v-slot="scope">
            <span v-if="scope.row.isLoadMaterial">需要</span>
            <span v-else>不需要</span>
          </template>
        </el-table-column>
        <el-table-column prop="workshopName" align="left" show-overflow-tooltip label="所属车间"/>
        <el-table-column label="操作" align="center" width="80px">
          <template v-slot="scope">
            <el-button type="danger" @click="onDeleteWorkCenter(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确实</el-button>
    </span>
    <employee-select ref="selectMember" @select="onSelectMember"/>
    <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter"/>
  </el-dialog>
</template>

<script>
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import workCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import constant from "../../../util/constant";
  export default {
    name: "WorkerGroupEdit",
    components: { EmployeeSelect, workCenterSelect },
    props: {
      groupTypeList: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        workerGroup: {
          pkId: 0,
          groupType: "",
          groupNo: "",
          groupName: "",
          groupLeaderId: "",
          groupLeaderName: "",
          note: "",
          status: 0,
          groupMembers: [],
          groupWorkCenters: [],
        },
        ruleValidate: {
          groupName: { required: true, message: "请输入班组名称", trigger: "blur" },
          groupType: { required: true, message: "请选择班组类型", trigger: "change" },
          groupLeaderName: { required: true, message: "请选择班组长", trigger: "change" },
        },
        groupMembersDetail: [],
        groupWorkCentersDetail: [],
      };
    },
    methods: {
      open(id) {
        this.workerGroup.pkId = id;
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        }
      },

      // 根据班组Id查看详情
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `workerGroups/${this.workerGroup.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.workerGroup = Object.assign(this.workerGroup, resp.data);
              this.groupWorkCentersDetail = resp.data.groupWorkCentersDetail;
              this.groupMembersDetail = resp.data.groupMembersDetail;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择班组长
      onSelectLeader(row) {
        this.workerGroup.groupLeaderId = row.employeeID;
        this.workerGroup.groupLeaderName = row.employeeName;
      },

      // 选择班组成员
      onSelectMember(row) {
        let flag = false;
        for (let item of this.groupMembersDetail) {
          if (item.employeeID === row.employeeID) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          let params = {
            employeeID: row.employeeID,
            employeeNO: row.employeeNO,
            employeeName: row.employeeName,
            departmentName: row.departmentName,
            postName: row.postName,
            outerNo: row.outerNo,
            gender: row.gender,
            address: row.address,
            telephone: row.telephone,
            mobile: row.mobile,
          };
          this.groupMembersDetail.push(params);
        } else {
          this.$confirm("该班组成员已存在,不能重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
        }
      },

      //选择班组工作中心
      onSelectWorkCenter(row) {
        let flag = false;
        for (let item of this.groupWorkCentersDetail) {
          if (item.pkId === row.pkId) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          let params = {
            pkId: row.pkId,
            workCenterNo: row.workCenterNo,
            workCenterName: row.workCenterName,
            productionTypeName: row.productionTypeName,
            bindVehicleTypeName: row.bindVehicleTypeName,
            isLoadMaterial: row.isLoadMaterial,
            workshopName: row.workshopName,
          };
          this.groupWorkCentersDetail.push(params);
        } else {
          this.$confirm("该班组工作中心已存在,不能重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
        }
      },

      // 删除班组成员
      onDeleteMember(index) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.groupMembersDetail.splice(index, 1);
        });
      },

      // 删除工作中心
      onDeleteWorkCenter(index) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.groupWorkCentersDetail.splice(index, 1);
        });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            //班组成员
            let groupMembers = [];
            this.groupMembersDetail.forEach((item, index) => {
              let member = {
                memberId: item.employeeID,
                rowIndex: index + 1,
              };
              groupMembers.push(member);
            });
            this.workerGroup.groupMembers = groupMembers;
            //班组工作中心
            let groupWorkCenters = [];
            this.groupWorkCentersDetail.forEach((item) => {
              let workCenter = {
                workCenterId: item.pkId,
              };
              groupWorkCenters.push(workCenter);
            });
            this.workerGroup.groupWorkCenters = groupWorkCenters;
            this.$http
              .save("basic", "workerGroups", this.workerGroup)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.workerGroup.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
// 加载效果水平垂直居中
.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}
// 标题
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>
